export default "<ion-app>\r\n  <app-left-menu user=\"Persona\"></app-left-menu>\r\n  <ion-router-outlet id=\"main\"></ion-router-outlet>\r\n</ion-app>";